/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  PRODUCT_TYPE, NeedShowDeliveryGuarantee, NeedShowWorryFreePurchase, NeedShowMakeItReturnable, PRODUCT_NAME,
} from '@constants';
import {
  BUYER_PROTECTION_POLICY_DETAIL_GRID, RETURN_ASSURANCE_POLICY_DETAIL_GRID,
  SHOPLAZZA_BUYER_PROTECTION_POLICY_DETAIL_GRID, ASSURED_SALE_POLICY_DETAIL_GRID, EXTENDED_WARRANTY_POLICY_DETAIL_GRID, WORRY_FREE_PURCHASE_POLICY_DETAIL_GRID,
} from './constants';
import { GridPanel } from './components/GridPanel';

export const PolicyDetailAssurance = React.memo(({ policyDetail, type, platform }) => {
  if (!policyDetail) {
    return null;
  }

  const {
    raPolicyRaDetailVO, raPolicyClaimsVO, getClaimDetailResponse = [], policyType, coveredLiabilityList = [],
  } = policyDetail;

  const {
    coveragePeriodStart: startTime = '',
    coveragePeriodEnd: endTime = '',
    returnMethod = '',
    customer = {},
    premium = '',
    orderName = '',
    customerCurrency, shopCurrency, customerPremium, shopPremium, shopCurrencySymbol,
    extraParam: {
      seller_username: sellerUsername, treet_shop_id: treetShopId,
      seller_platform: sellerPlatform,
    } = {},
  } = raPolicyRaDetailVO || {};

  const { totalShippingFee = '', totalBuybackFee = '' } = raPolicyClaimsVO || {};

  const data = {
    coveragePeriod: {
      startTime,
      endTime,
    },
    returnMethod,
    customer,
    premium: {
      value: premium, customerCurrency, shopCurrency, customerValue: customerPremium, shopValue: shopPremium,
    },
    orderName: {
      orderName, sellerUsername, treetShopId, sellerPlatform, platform,
    },
    totalShippingFee: {
      value: totalShippingFee, customerCurrency, shopCurrencySymbol, shopCurrency,
    },
    totalBuybackFee: {
      value: totalBuybackFee, customerCurrency, shopCurrency, shopCurrencySymbol,
    },
    covers: coveredLiabilityList.join(', ') || '--',
    coverage: coveredLiabilityList || [],
  };
  const assuranceMap = {
    [PRODUCT_TYPE.Return]: RETURN_ASSURANCE_POLICY_DETAIL_GRID(NeedShowMakeItReturnable.includes(policyType)),
    [PRODUCT_TYPE.Buyer]: platform === 'Shoplazza' ? SHOPLAZZA_BUYER_PROTECTION_POLICY_DETAIL_GRID : BUYER_PROTECTION_POLICY_DETAIL_GRID(NeedShowDeliveryGuarantee.includes(policyType), NeedShowWorryFreePurchase.includes(policyType)),
    [PRODUCT_TYPE.Assured]: ASSURED_SALE_POLICY_DETAIL_GRID,
    [PRODUCT_TYPE.Extended]: EXTENDED_WARRANTY_POLICY_DETAIL_GRID,
    [PRODUCT_TYPE.WorryPurchase]: WORRY_FREE_PURCHASE_POLICY_DETAIL_GRID,
  };
  const rows = assuranceMap[type];
  // remove Return shipping fee part 新理赔部分显示了
  if (type === PRODUCT_TYPE.Return && (getClaimDetailResponse.length || ['Treet', 'Gently', 'Garmentory'].includes(platform))) {
    rows[1].pop();
  }
  return (
    <GridPanel
      rows={rows}
      data={data}
      title={type === PRODUCT_TYPE.Return ? `${NeedShowMakeItReturnable.includes(policyType) ? PRODUCT_NAME.RETURNABLE : PRODUCT_NAME.RETURN_ASSURANCE}` : ''}
    />
  );
});
